import { COUNTRIES } from '@/types/user';

/**
 * Get country name from country code
 */
export const getCountryName = (countryCode: string | undefined): string => {
  if (!countryCode) return '';
  
  const country = COUNTRIES.find(c => c.code === countryCode);
  return country?.name || '';
};

/**
 * Check if country code is valid
 */
export const isValidCountryCode = (countryCode: string | undefined): boolean => {
  if (!countryCode) return false;
  return COUNTRIES.some(c => c.code === countryCode);
};